import React, { useState } from "react";
import "./../AdminPackage.css";

import ReactHtmlParser from "react-html-parser";
function AboutDetails(props) {
  return (
    <>
      <div className="chkDetails">
        <ul>
          <li>
            Check in{" "}
            <span className="latoBlack"> {props?.detailsAbout?.check_in}</span>
          </li>
          <li>
            Check out{" "}
            <span className="latoBlack"> {props?.detailsAbout?.check_out}</span>
          </li>
        </ul>
        <p>
          <p
            style={{
              display: "inline-block",
              textAlign: "justify",
            }}
          >
            <span className="activity-row-text-desc">
              {props?.detailsAbout?.property_source == 1 ? (
                props?.JuniperDesc.length >0 ? (
                  props?.JuniperDesc.map((item, key) => (
                    <p>{ReactHtmlParser(item?.description)}</p>
                  ))
                ) : (
                  <> </>
                )
              ) : (
                <p>
                  {ReactHtmlParser(props?.detailsAbout?.property_description)}
                </p>
              )}
            </span>
           
          </p>
        </p>
        {props?.detailsAbout?.property_source != 1 && (
        <>
          <p
            className="txtHeading font18 latoBlack blackText"
            style={{ marginLeft: "13%", marginBottom: "2px" }}
          >
            Nearby Area:
          </p>
          <div class="abpp__bottom--left appendRight10 nearbyleft">
            <ul>
              {props?.neighbourhoodareas &&
                props?.neighbourhoodareas.map((newitem, key2) => (
                  <li>
                    <span className="latoBlack latoblacknearby">
                      {newitem?.neighbourhood_category}:{" "}
                    </span>
                    &nbsp;{" "}
                    <p>
                      {newitem?.value} ({newitem?.distance})
                    </p>{" "}
                  </li>
                ))}
            </ul>
          </div>
        </>
      )}
      </div>
   
    </>
  );
}

export default AboutDetails;
